import React from "react";
import { Breadcrumb, Row, Col, Typography, Tabs, Skeleton } from "antd";
import { Link } from "react-router-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
const { Title, Text } = Typography;
export default function PageTitle({ title, total, loading }) {
  return (
    <div>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link
              to="/"
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.RETURN,
                  GA.DESCRIPTION.RETURN_TO_HOME
                );
              }}
            >
              {" "}
              Home
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{title}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <Row
        style={{
          marginTop: "20px",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Title level={3} style={{ fontFamily: "Gilroy" }}>
          {title}
        </Title>
        {!loading && <Text style={{ padding: "0 0 7px 10px" }}>({total})</Text>}
      </Row>
    </div>
  );
}
